import { Box } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";

import { HourGlass } from "../../components";
import { RedError } from "../../components/common/red-error";
import { getBody } from "../../constants";
import { ErrorType, Role, TokenResp } from "../../models";
import { RootState } from "../../store";
import { authSliceActions } from "../../store/auth-slice";
import { useGetTokenMutation } from "../../store/rtk";
import { useLazyGetRoleQuery } from "../../store/rtk/admin-api";

export const AuthCallback = () => {
  const [err, setErr] = useState("");
  const called = useRef(false);
  const [searchParams] = useSearchParams();
  const [isGettingToken, setIsGettingToken] = useState(true);
  const [getToken, { error }] = useGetTokenMutation();
  const [getRole] = useLazyGetRoleQuery();
  const [authCode, setAuthCode] = useState<string | null>(null);
  const paramsCode = searchParams.get("code");
  const isLoggedIn = useSelector((state: RootState) => state.auth.isLoggedIn);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // const [sendLogs] = useSendLogsMutation();

  useEffect(() => {
    if (error) {
      setIsGettingToken(false);
      setErr(`${error}`);
    }
  }, [error]);

  useEffect(() => {
    if (paramsCode) setAuthCode(paramsCode);
  }, [paramsCode]);

  useEffect(() => {
    // console.log(" Auth callback body : ", body);
    (async () => {
      if (isLoggedIn === false) {
        try {
          if (!authCode || called.current) return; // prevent rerender caused by StrictMode
          called.current = true;
          // console.log(" Auth callback code verifier : ", body.codeVerifier);

          // const cCha = localStorage.getItem("codeChallenge");
          // const validChallenge = await bcrypt.compare(body.codeVerifier!, cCha!);
          // await sendLogs(sendLogBody(`code verifier 🌑AFTER🌑 redirection : ${body.codeVerifier}`));
          // await sendLogs(sendLogBody(`code challenge 🌑AFTER🌑 redirection : ${cCha}`));
          // await sendLogs(sendLogBody(`Valid code challenge 🌑AFTER🌑 redirection : ${validChallenge}`));
          const body = await getBody();
          const getTokenData = {
            authCode: authCode,
            clientId: body.clientId,
            grantType: "authorization_code",
            codeVerifier: body?.codeVerifier!,
          };
          const serverRes = (await getToken(getTokenData)) as { data: TokenResp; error: ErrorType };
          // console.log(" == Auth callback code verifier : ", body.codeVerifier);

          if (serverRes.error) return;

          dispatch(
            authSliceActions.login({
              accessToken: serverRes.data.accessToken,
              refreshToken: serverRes.data.refreshToken,
              refreshTokenExp: Date.now() + serverRes.data.refreshTokenExpiresIn * 1000,
            })
          );

          const role = (await getRole(null)) as { data: { role: Role }[]; error: ErrorType };
          // console.log("Role obj :", role);

          if (role.error) {
            dispatch(authSliceActions.logout());
            navigate("/login", { state: { noAccount: role.error } });
          }
          const transFormedRoles = Array.isArray(role.data) ? role.data.map(r => r.role) : [];

          // const token = decodeToken(serverRes.data.accessToken as string);

          setIsGettingToken(false);
          transFormedRoles.forEach(role => {
            if (role === "admin" || role === "superAdmin") {
              navigate("/progress-admin");
              return;
            } else if (role === "student") {
              navigate("/progress");
            }
          });
        } catch (err) {
          dispatch(authSliceActions.logout());

          navigate("/login", { state: { err: true } });
        }
      }
    })();
  }, [isLoggedIn, navigate, authCode, getToken, dispatch, getRole]);

  return (
    <>
      {err && <RedError message={err} />}
      {(!err || isGettingToken) && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            height: "100vh",
            overflowY: "hidden",
          }}
        >
          <Box mb={2}>
            <HourGlass />
          </Box>
          <h3 style={{ textAlign: "center" }}>Authenticating ...</h3>
        </div>
      )}
    </>
  );
};
